var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91406 8.49609C6.81641 8.76562 6.76367 9.13281 6.75586 9.59766H7.83984C7.83984 9.00391 7.98242 8.54883 8.26758 8.23242L8.90625 7.59961C9.53906 6.93555 9.85547 6.26172 9.85547 5.57812C9.85547 4.88672 9.64844 4.34375 9.23438 3.94922C8.82422 3.55078 8.25 3.35156 7.51172 3.35156C6.80078 3.35156 6.22266 3.54688 5.77734 3.9375C5.33594 4.32422 5.11133 4.83398 5.10352 5.4668H6.1875C6.1875 5.11133 6.30859 4.82812 6.55078 4.61719C6.79297 4.40625 7.11328 4.30078 7.51172 4.30078C7.92188 4.30078 8.23438 4.41797 8.44922 4.65234C8.66406 4.88281 8.77148 5.20312 8.77148 5.61328C8.77148 6.03906 8.60742 6.4375 8.2793 6.80859L7.51172 7.59961C7.21094 7.92773 7.01172 8.22656 6.91406 8.49609Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86719 11.0156C6.76172 11.1328 6.70898 11.2793 6.70898 11.4551C6.70898 11.6309 6.76172 11.7773 6.86719 11.8945C6.97656 12.0078 7.13672 12.0645 7.34766 12.0645C7.55859 12.0645 7.71875 12.0078 7.82812 11.8945C7.9375 11.7773 7.99219 11.6309 7.99219 11.4551C7.99219 11.2793 7.9375 11.1328 7.82812 11.0156C7.71875 10.8945 7.55859 10.834 7.34766 10.834C7.13672 10.834 6.97656 10.8945 6.86719 11.0156Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM14.25 7.5C14.25 11.2279 11.2279 14.25 7.5 14.25C3.77208 14.25 0.75 11.2279 0.75 7.5C0.75 3.77208 3.77208 0.75 7.5 0.75C11.2279 0.75 14.25 3.77208 14.25 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpAbout);
export default __webpack_public_path__ + "static/media/icon-help-about.ada09273814311b4bf0e4b1163044f4b.svg";
export { ForwardRef as ReactComponent };